import { useAuth } from "../context/AuthContext";
import { apiGet, apiPost } from "./apiClient";

/**
 * useApi hook: centralized API calls with JWT
 */
export const useApi = () => {
  const { idToken } = useAuth(); // automatically gets JWT from context

  const get = async (url) => {
    return await apiGet(url, idToken);
  };

  const post = async (url, data) => {
    return await apiPost(url, data, idToken);
  };
  const postWithIdToken = async (url, data,idToken) => {
    return await apiPost(url, data, idToken);
  };

  return { get, post, postWithIdToken };
};
